/**
 * KAN-735: деньги в интерфейсе: рубли целыми с разделителем тысяч (как в истории
 * платежей), доллары с двумя знаками, разбор суммы из поля ввода.
 */

/** 1234.6 -> "1 235 ₽". */
export function formatRub(value: number): string {
  return `${Math.round(Number(value) || 0).toLocaleString('ru-RU')} ₽`;
}

/** KAN-745: рубли с копейками: 6172.8 -> "6 172,80 ₽". */
export function formatRubKopecks(value: number): string {
  const n = Number(value) || 0;
  return `${n.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₽`;
}

/** 12.5 -> "$12.50". */
export function formatUsd(value: number): string {
  return `$${(Number(value) || 0).toFixed(2)}`;
}

/** Текст ошибки поля стоимости. */
export const RUB_AMOUNT_ERROR = 'Стоимость: число от 0';

/**
 * Сумма в рублях из поля ввода: пробелы убираются, запятая как точка.
 * Пусто, отрицательное или не число: null.
 */
export function parseRubAmount(raw: string): number | null {
  const text = (raw ?? '').replace(/\s/g, '').replace(',', '.');
  if (!text || !/^\d+(\.\d+)?$/.test(text)) return null;
  const n = Number(text);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

/** Ошибка поля стоимости или null (пустое поле допустимо). */
export function validateRubAmount(raw: string): string | null {
  if (!(raw ?? '').trim()) return null;
  return parseRubAmount(raw) === null ? RUB_AMOUNT_ERROR : null;
}
